import coreUtils from "../../../assets/scripts/core-utils.js";
import jQuery from "jquery";

const $ = jQuery;

const coreEditorialSection = (($) => { // eslint-disable-line

  const me = {};

  me.init = function() {

    coreUtils.initVideo($('.js-video .video-thumbnail, .js-video .video-icon'));

  };

  return me;

})(jQuery);

export default coreEditorialSection;
